// extracted by mini-css-extract-plugin
export default {"compareChartsCardContainer":"CompareChartsCard_compareChartsCardContainer__SZN6N","compareChartsCardChart":"CompareChartsCard_compareChartsCardChart__2c0yw"};